module.exports = __webpack_public_path__ + "static/media/pe.ef9dac1d.svg";